
import Vue from 'vue'

import Cart from './components/Cart.vue'
import Header from './components/Header.vue'
import ProductTile from './components/ProductTile.vue'
import { product } from './types'

export default Vue.extend({
  name: 'App',
  components: {
    Cart,
    Header,
    ProductTile
  },
  computed: {
    products(): product[] {
      return this.$store.state.products
    }
  },
  mounted() {
    this.$store.dispatch('getProducts')
  }
})
